import { useRef } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Rejecter = (reason?: any) => void;
type Resolver<T> = (value: PromiseLike<T> | T) => void;

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const useControlledPromise = <T extends unknown>() => {
  const newResolve = useRef<Resolver<T>>(() => {});
  const newReject = useRef<Rejecter>(() => {});

  // https://stackoverflow.com/questions/41078809/typescript-promise-generic-type
  // https://beta.reactjs.org/reference/react/useRef#avoiding-recreating-the-ref-contents
  const promise = useRef<null | Promise<T>>(null);

  promise.current ??= new Promise<T>((resolve, reject) => {
    newResolve.current = resolve;
    newReject.current = reject;
  });

  return {
    promise,
    reject: newReject,
    resolve: newResolve,
  };
};
